import bulmaCollapsible from '@creativebulma/bulma-collapsible';

// const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible');
const bulmaCollapsibleInstances = document.querySelectorAll('.is-collapsible');

// Loop into instances
bulmaCollapsibleInstances.forEach(element => {
    // Check if current state is collapsed or not
    const bulmaCollapsibleInstance = new bulmaCollapsible(element);

    if (element.classList.contains('force-active')) {
        bulmaCollapsibleInstance.expand();
    }
});

// Code for Navbar Burger from Bulma.io

// Get all "navbar-burger" elements
const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

// Check if there are any navbar burgers
if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
        el.addEventListener('click', () => {
            // Get the target from the "data-target" attribute
            const target = el.dataset.target;
            const $target = document.getElementById(target);

            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle('is-active');
            $target.classList.toggle('is-active');
        });
    });
}

document.addEventListener("DOMContentLoaded", function(event) {
    // Your code to run since DOM is loaded and ready
    const checkoutButton = document.querySelector('button#place_order.button.alt');
    if (checkoutButton) {
        checkoutButton.click();
    }
});

jQuery(document).ready(function ($) {
  // Bind an event handler to the "change" event on the quantity input field
  $(".qty").on("change", function () {
    // Get the updated quantity value
    var updatedQuantity = $(this).val();

    // Find the nearest anchor tag and update its data-quantity attribute
    var nearestAnchor = $(this).closest(".product").find(".add_to_cart_button");
    console.log(nearestAnchor);
    nearestAnchor.attr("data-quantity", updatedQuantity);
  });
});

document.addEventListener("DOMContentLoaded", function (event) {
  // Your code to run since DOM is loaded and ready
  const placeOrderButton = document.querySelector("a#order-submit-button");
  console.log(placeOrderButton);
  // add event listener click to place order button
  if (placeOrderButton) {
    placeOrderButton.addEventListener("click", function () {
      console.log("clicked");
      const customerNotes = document.getElementById("customer_notes");
      const customerNotesText = document.getElementById("customer_notes_text");
      const form = document.getElementById("checkout_form");
      if (customerNotes) {
        if (customerNotesText && customerNotesText.value != "") {
          customerNotes.value = customerNotesText.value;
        } else {
          customerNotes.value = "";
        }
      }

      form.submit();
    });
  }
});
